import PSprite from './PSprite';
import ObjectPool from './ObjectPool';
import DataModel from './DataModel';
import AudioConst from './AudioConst';
export default class AudioDail extends PSprite {
    constructor() {
        super();
        this.pool = new ObjectPool();
        this.canvas = new PIXI.Graphics();
        this.addChild(this.canvas);
        this._range = new DataModel({
            min : 0,
            max : Infinity,
        });
        this._range.on("min", this.dirty, this);
        this._range.on("max", this.dirty, this);
    }

    set interval(value) {
        this._interval = value;
    }

    get range(){
        return this._range;
    }

    redraw() {
        this.clear();
        let half = this._interval/2;
        let start = Math.ceil(this._range.min/half)*half;
        let end = this._range.max;

        let y = AudioConst.DAIL_H;
        this.canvas.lineStyle(1, 0x696969);
        this.canvas.moveTo(this.range.min, y);
        this.canvas.lineTo(this.range.max, y);

        y -= 0.5;
        for(let i=start; i < end; i+=half) {
            if((i/half)%2 == 0) { //整秒
                this.canvas.moveTo(i+1, y);
                this.canvas.lineTo(i+1, y - 5);
                let tf = this.getTF((i/this._interval).toString());
                tf.x = i - tf.width / 2;
                tf.y = -1;
                this.addChild(tf);
            }else { //半秒
                this.canvas.moveTo(i+1, y);
                this.canvas.lineTo(i+1, y - 3);
            }
        }
    }

    clear() {
        this.canvas.clear();
        let len = this.children.length;
        while(--len > 0) { //第0个元素是canvas
            let tf = this.getChildAt(len);
            this.removeChild(tf);
            this.pool.push("tf", tf);
        }
    }

    getTF(text) {
        let tf = this.pool.pop("tf");
        if(!tf) {
            tf = new PIXI.Text(text, {fontFamily: 'Arial', fontSize: 12, fill: 0xE2E2E2, align: 'center'});
            const scale = 0.8;
            tf.scale = {x:scale, y:scale};
        }else {
            tf.text = text;
        }
        return tf;
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/AudioDail.js